import {
  BANK_ADDRESS_PARAM_IDS,
  type BankAddressStepParam,
} from '@/entities/bank-address';

export const normalizeBankAddressParams = (
  params: BankAddressStepParam[]
): BankAddressStepParam[] => {
  return params.map(param => {
    if (
      param.paramId === BANK_ADDRESS_PARAM_IDS.currencyCode &&
      param.defaultIndex !== undefined &&
      param.defaultIndex !== null &&
      typeof param.defaultIndex === 'string'
    ) {
      return {
        ...param,
        valueList: [param.defaultIndex],
      };
    }

    return param;
  });
};
